import { createApiEffect } from '@/features/api/common/create-api-effect'

export const checkExportProgressFx = createApiEffect<{ id: string; isArchive?: boolean }, Blob>({
  requestMapper: ({ id, isArchive }) => ({
    method: 'GET',
    url: `/api/tasks/${id}/`,
    ...(!isArchive && { responseType: 'blob' }),
  }),
})
